import { thingsToKeepInMind } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

interface Props {
    localization: ILocalization;
}

export const ThingsToKeepInMindSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='things-to-keep-in-mind-slide'>
                <img alt='' src={thingsToKeepInMind} />
            </div>
        </div>
    );
};

export const ThingsToKeepInMindSlideImageSrc = thingsToKeepInMind;

export const ThingsToKeepInMindSlideContent = ({ localization }: Props) => {
    const { thingsToKeepInMindSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial
            .supervisor.slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{thingsToKeepInMindSlide.thingsToKeep}</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {thingsToKeepInMindSlide.alwaysCheck}
                    <span className='instruction-content-bold'>
                        {thingsToKeepInMindSlide.statusChanges}
                    </span>
                    .
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {thingsToKeepInMindSlide.beMindfulOfDeadlines}{' '}
                    <span className='instruction-content-bold'>
                        {thingsToKeepInMindSlide.timelyFeedback}
                    </span>{' '}
                    {thingsToKeepInMindSlide.onTheStatuses}​
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {thingsToKeepInMindSlide.forFurther} ​
                </div>
            </div>
        </div>
    );
};
